export interface OperationLike {
  operationId: string;
}

export type OperationCurrent = string | string[] | OperationLike[] | null;

export function resolveCurrentOperationId(
  current: OperationCurrent,
  operationIds: string[]
): string | null {
  if (typeof current === 'string') {
    return operationIds.includes(current) ? current : null;
  }

  if (Array.isArray(current) && current[0] !== 'all-operations') {
    const first = current[0];
    const id = typeof first === 'string' ? first : (first as OperationLike).operationId;
    return operationIds.includes(id) ? id : null;
  }

  return null;
}

export function resolveOperationIds(
  current: OperationCurrent
): string[] | null {
  if (current === null) {
    return null;
  }

  if (typeof current === 'string') {
    return current === 'all-operations' ? null : [current];
  }

  if (Array.isArray(current)) {
    if (current[0] === 'all-operations') {
      return null;
    }
    return current.map((op: string | OperationLike) =>
      typeof op === 'string' ? op : op.operationId
    );
  }

  return null;
}
